if (!customElements.get("product-video-gallery")) {
  customElements.define(
    "product-video-gallery",
    class ProductVideoGallery extends HTMLElement {
      constructor() {
        super();
        this.videoWrappers = this.querySelectorAll(".product-video-gallery__item .video-wrapper");
      }

      connectedCallback() {
        if (this.videoWrappers.length === 0) return;

        this.videoWrappers.forEach((wrapper) => {
          wrapper.addEventListener("click", this.playPauseVideo.bind(this));
        });

        const firstVideoWrapper = this.videoWrappers[0];
        const firstVideo = firstVideoWrapper.querySelector("video");
        const firstPlayIcon = firstVideoWrapper.querySelector(".play-icon");

        if (firstVideo) {
          firstVideo.play();
          if (firstPlayIcon) firstPlayIcon.style.display = "none";
        }
      }

      playPauseVideo(event) {
        const wrapper = event.currentTarget;
        const video = wrapper.querySelector("video");
        const playIcon = wrapper.querySelector(".play-icon");

        if (!video) return;

        if (!video.paused) {
          video.pause();
          if (playIcon) playIcon.style.display = "block";
        } else {
          this.stopAllVideos(wrapper);
          video.play();
          if (playIcon) playIcon.style.display = "none";
        }
      }

      stopAllVideos(exceptWrapper = null) {
        this.videoWrappers.forEach((wrapper) => {
          if (wrapper === exceptWrapper) return;

          const video = wrapper.querySelector("video");
          const playIcon = wrapper.querySelector(".play-icon");

          if (video && !video.paused) {
            video.pause();
            if (playIcon) playIcon.style.display = "block";
          }
        });
      }
    }
  );
}
